import { shallowEqual, useSelector } from 'react-redux';

const useIs12HoursTimeFormat = () => {
  const timeFormat = useSelector((state) => state?.auth?.getUserPreference?.data?.timeFormat, shallowEqual);
  return timeFormat === 12 || timeFormat === 'TwelveHour';
};

export default useIs12HoursTimeFormat;
